"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var de_1 = require("./de"),
    en_1 = require("./en"),
    Strings = function () {
  function e() {}

  return e.prototype.localized = function (e) {
    var t = this.getStringsConst();
    return Object.keys(t).includes(e) ? t[e] : e;
  }, e.prototype.getPreferredLanguageCode = function () {
    return require("browser-locale")().substring(0, 2).toLowerCase();
  }, e.prototype.getLanguage = function () {
    return this.forcedLanguage ? this.forcedLanguage : this.getPreferredLanguageCode();
  }, e.prototype.getStringsConst = function () {
    switch (this.getLanguage()) {
      case "de":
        return de_1.StringsDE;

      default:
        return en_1.StringsEN;
    }
  }, e;
}();

exports.Strings = Strings;